module.exports = __webpack_public_path__ + "img/front-lawyer.f75152b1.jpeg";